<page-headline
    [linkTitle]="'Historical Trends'"
    [module]="'historical-trends'"
    [moduleIcon]="'fa-chart-line'"
    [moduleLink]="'historical-trends'"
    [pageTitle]="'Historical Trends Upgrade'"
>
</page-headline>
<module-upgrade
    [headline]="headline"
    [shortOverview]="shortOverview"
    [selligPointHeader]="selligPointHeader"
    [logoPlaceholder]="logoPlaceholder"
    [moduleShortDescription]="moduleShortDescription"
    [backgroundColor]="backgroundColor"
>
</module-upgrade>
